import React from 'react';
import { AwardIcon, CheckCircle2Icon } from 'lucide-react';
import { Button } from './ui/Button';
import { SectionHeading } from './ui/SectionHeading';
import { checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-pearl py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-133" data-mp="1j9740qqiilye">
      <div className="mx-auto max-w-3xl px-4" data-id="element-134" data-mp="1n9ipg5qp8qax">
        <SectionHeading id="pricing-title" data-id="element-135" data-mp="1ncwr1brjgvhb">Choose Your <span className="text-aqua" data-id="element-136" data-mp="1s8u5tdn5ltrz">Option</span></SectionHeading>

        <article className="mt-10 overflow-hidden rounded-2xl border-2 border-gold bg-white shadow-lg" data-id="element-137" data-mp="1x8qbdhbi1t9n">
          <div className="border-b border-gray-200 bg-navy px-6 py-4 sm:px-10" data-id="element-138" data-mp="227jh2nkjofz9">
            <span className="inline-flex items-center gap-2 rounded-full border border-gold/50 px-3 py-1.5 text-xs font-semibold text-gold" data-id="element-139" data-mp="225gr23je6muj">
              <AwardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-140" data-mp="7t0g4pfnikjc" /> Main Offer
            </span>
          </div>
          <div className="p-6 sm:p-10" data-id="element-141" data-mp="1mhgc4raxdhd9">
            <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-142" data-mp="1mihor07labx3">
              <div data-id="element-143" data-mp="1ho50mcv64cf0">
                <h3 className="text-2xl font-bold leading-tight tracking-tight text-navy sm:text-3xl" data-id="element-144" data-mp="1cqlnjga7i5on">{productShortName}</h3>
                <p className="mt-2 text-sm text-gray-600" data-id="element-145" data-mp="17sjvw6ypsy1k">
                  All {totalVolumes} volumes + {totalBonuses} exclusive bonuses
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-146" data-mp="20gphsx1i8t2z">
                <span className="text-sm text-gray-500" data-id="element-147" data-mp="20h8vu2o1axbq">
                  Regular price: <span className="line-through decoration-gray-400 decoration-2" data-id="element-148" data-mp="1vgbdnq30y3a8">{priceBefore}</span>
                </span>
                <p className="mt-2 text-xs font-semibold uppercase tracking-wider text-gold-dark" data-id="element-149" data-mp="1rfhutb4fveo7">Today:</p>
                <p className="mt-1 whitespace-nowrap text-5xl font-bold leading-none tracking-tight text-navy sm:text-6xl" data-id="element-150" data-mp="k039jk7y2jwg">{price}</p>
              </div>
            </div>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" trackCheckout arrow className="mt-9 w-full" data-id="element-151" data-mp="hj2vgtzs9zco">
              Get my professional edition now
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-gray-600" data-id="element-152" data-mp="7isinahnuty1">
              {['Secure payment', 'Instant access', '7-day guarantee'].map(item => <span key={item} className="inline-flex items-center gap-1.5" data-id="element-153" data-mp="3uweb67ibyboj">
                  <CheckCircle2Icon className="h-4 w-4 text-aqua" aria-hidden="true" data-id="element-154" data-mp="3hqjsurnojwl" /> {item}
                </span>)}
            </div>
          </div>
        </article>
      </div>
    </section>;
}